/* global axios */
import ApiClient from './ApiClient';

class PostSaleCaseNotificationsAPI extends ApiClient {
  constructor() {
    super('post_sale_case_notifications', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  markRead(id) {
    return axios.patch(`${this.url}/${id}`);
  }
}

export default new PostSaleCaseNotificationsAPI();
